import { render, staticRenderFns } from "./myInvoice.vue?vue&type=template&id=2facfbc3&scoped=true"
import script from "./myInvoice.vue?vue&type=script&lang=js"
export * from "./myInvoice.vue?vue&type=script&lang=js"
import style1 from "./myInvoice.vue?vue&type=style&index=1&id=2facfbc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2facfbc3",
  null
  
)

export default component.exports